/**
 * Creates a URL builder for a given resource path.
 * @param {string} resource - The base resource name (e.g. 'user', 'role')
 * @returns {function(string|null): string} URL builder function
 */
export const buildResourceUrl = (resource) => (path = null) =>
  resource + (path === null ? '' : `/${path}`)

// Backward-compat alias used by repositories until they are updated
export const useUrl = buildResourceUrl
